webpackJsonp([1],{

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfc5a95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("msyC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfc5a95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MvLH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('md-layout',[_c('md-icon',[_vm._v("build")]),_vm._v(" "),_c('span',{staticClass:"md-caption"},[_c('em',[_vm._v(" Website Under Construction")])]),_vm._v(" "),_c('md-icon',[_vm._v("build")])],1),_vm._v(" "),_c('md-toolbar',[_c('h1',{staticClass:"md-title",staticStyle:{"flex":"1"}},[_vm._v("MLJ Networks Limited")]),_vm._v(" "),_c('md-icon',[_vm._v("contact_mail")]),_vm._v(" "),_c('span',{staticClass:"md-caption"},[_c('em',[_vm._v(" info@mljnetworks.com")])])],1),_vm._v(" "),_c('md-tabs',{attrs:{"md-navigation":""}},[_c('md-tab',{attrs:{"id":"intro","md-label":"Introduction"}},[_c('p',[_vm._v("MLJ Networks are UK based, providing IT/Network Engineering and Consultancy services")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Full Spectrum")]),_vm._v(" "),_c('li',[_vm._v("Pragmatic")]),_vm._v(" "),_c('li',[_vm._v("Vendor Agnostic")])]),_vm._v(" "),_c('p',[_vm._v("Experience in Telecoms, Service Provider, Vendor, Systems Integrator and Enterprise IT")]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('md-tab',{attrs:{"id":"engineering","md-label":"engineering"}},[_c('p',[_vm._v("Total Lifecycle Management")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Architecture and Design")]),_vm._v(" "),_c('li',[_vm._v("Installation and Commisioning")]),_vm._v(" "),_c('li',[_vm._v("Support and Troubleshooting")])]),_vm._v(" "),_c('p',[_vm._v("Professional Services")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("On-Site")]),_vm._v(" "),_c('li',[_vm._v("Cloud")]),_vm._v(" "),_c('li',[_vm._v("Project Delivery")])])]),_vm._v(" "),_c('md-tab',{attrs:{"id":"consultancy","md-label":"consultancy"}},[_c('p',[_vm._v("Development")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("OSS Integration")]),_vm._v(" "),_c('li',[_vm._v("Network Management")]),_vm._v(" "),_c('li',[_vm._v("Responsive Pragmatic Design")])]),_vm._v(" "),_c('p',[_vm._v("Management")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Team Building")]),_vm._v(" "),_c('li',[_vm._v("Mentoring")]),_vm._v(" "),_c('li',[_vm._v("Vendor Selection")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__("tzNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// vue-material js and css


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);

// change default palette
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: {
    color: 'blue-grey',
    hue: 400
  },
  accent: {
    color: 'blue-grey',
    hue: 200
  },
  background: {
    color: 'blue-grey',
    hue: 600
  }
});

// secondary palette
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('secondary', {
  primary: {
    color: 'light-green',
    hue: 400
  },
  accent: {
    color: 'light-green',
    hue: 200
  },
  background: {
    color: 'light-green',
    hue: 600
  }
});



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "msyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('hello')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9bc1cd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("MvLH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9bc1cd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__("qSdX");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d51e8ece3848554b60d7.js